



























































































































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import {Action, Getter, Mutation} from 'vuex-class';
import AccOrgAutocomplete from '@/components/AccOrgAutocomplete.vue';
import {
  AdminSubscriptionSummary,
  CommercialAccount,
  IDataTableHeader,
  Organisation,
  Project, Subscription,
  SubscriptionOrder, User,
} from '@/types';
import {debounce} from '@/classes/utils';
import EventBus from '@/services/eventbus.service';
import AccountService from '@/services/account.service';
import ProjectService from '@/services/project.service';
import Table from '@/components/Table.vue';
import Transformation from '@/classes/transformation';
import ActionBarButton from '@/components/ActionBarButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import Dialog from '@/components/Dialog.vue';
import GenericButton from '@/components/GenericButton.vue';
import TransferSubscriptions from '@/components/subscriptions/TransferSubscriptions.vue';
import SubscriptionsService from '@/services/subscriptions.service';
import moment from 'moment';

@Component({
  components: {
    TransferSubscriptions,
    GenericButton, Dialog, CancelButton, ConfirmButton, ActionBarButton, Table, AccOrgAutocomplete, SearchBar},
})
export default class AccountSubscriptions extends Vue {
  @Getter private hasPermission: any;
  @Getter private layout!: any;
  @Getter private activeAccountId!: any;
  @Getter private activeAccount!: any;
  @Mutation private setSubscriptionViewLayout: any;
  @Action private addOrganisationsAsync: any;
  private account: CommercialAccount | null = null;
  private organisations: Organisation[] = [];
  private loading: boolean = false;
  private search: string = '';
  private expiresBetweenSelected: { text: string; value: { start: Date; end: Date } | boolean } | null = null;
  private dates: string[] = [];
  private menu: boolean = false;
  private selectedOrganisation: Organisation | null = null;
  private exclusion: string | null = null;
  private selectedProject: Project = {} as Project;
  private selectedSubscriptionOrderId: number | null = null;
  private projects: Project[] = [];
  private page: number = 1;
  private perPage: number = 100;
  private itemsPerPage: number = 100;
  private nonce = 1;
  private externalFilters: any = {};

  private users: User[] = [];
  private currentAuditHistory: any = [];
  private showAuditHistory: boolean = false;
  private loadingAudits: { [key: string]: boolean } = {};
  private options: any = { itemsPerPage: 12 };
  private auditHeaders: any = [
    { text: 'Type', value: 'sub_category', width: 130 },
    { text: 'Summary', value: 'summary', width: 400 },
    { text: 'User', value: 'user_id' },
    { text: 'Date', value: 'created_at' },
    { text: 'Timestamp', value: 'timestamp' },
  ];

  private selectedSubscriptions: any[] = [];
  private showTransferSubscriptionAction = false;
  private showDisableRenewalSubscriptionAction = false;
  private showEnableRenewalSubscriptionAction = false;
  private showTerminateSubscriptionAction = false;
  private loadingAction = false;
  private promptToDisableRenewal = false;
  private promptToTransfer = false;
  private promptToTerminate = false;

  private expiresBetweenItems: any[] = [
    { id: 1, text: 'In the next week', value: this.thisWeek },
    { id: 2, text: 'In the next 30 days', value: this.next30Days },
    { id: 3, text: 'This month', value: this.thisMonth },
    { id: 4, text: 'Next month', value: this.nextMonth },
    { id: 5, text: 'This calendar quarter', value: this.thisQuarter },
    { id: 6, text: 'Next calendar quarter', value: this.nextQuarter },
    { id: 7, text: 'Custom range', value: this.dates },
    { id: 8, text: 'Already expired', value: true },
  ];

  private delaySearchFilter = debounce((func: any) => {
    func();
  }, 750);

  private queryData: any = { sort: 'suborder.order_number' };
  private tableData: { headers: any[], rows: any[], total: number, counts: {} } = {
    counts: {},
    rows: [],
    total: 0,
    headers: [
      {
        text: 'Subscription id',
        value: 'subscription_id',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Order reference',
        value: 'order_number',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'orderNumbers',
        querySortKey: 'order_number',
      },
      {
        text: 'Subscription product',
        value: 'subscription_product',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'subscriptionProducts',
        querySortKey: 'subscription_product',
      },
      {
        text: 'Product code',
        value: 'product_code',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'productCodes',
        querySortKey: 'product_code',
      },
      {
        text: 'Status',
        value: 'status',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'statuses',
        querySortKey: 'subscription_status',
        cellClass: 'text-capitalize',
        class: 'text-capitalize',
      },
      {
        text: 'Created on',
        value: 'subscription_created_at',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionCreatedAt',
        querySortKey: 'subscription_created_at',
      },
      {
        text: 'Activated on',
        value: 'subscription_activated_at',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionActivatedAt',
        querySortKey: 'subscription_activated_at',
      },
      {
        text: 'End of term',
        value: 'subscription_expires_at',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionExpiresAt',
        querySortKey: 'subscription_expires_at',
      },
      {
        text: 'Activate by',
        value: 'subscription_activate_by',
        align: 'start',
        sortable: false,
        timeFilter: true,
        timeFilterKey: 'subscriptionActivateBy',
        querySortKey: 'subscription_activate_by',
      },
      {
        text: 'Organisation',
        value: 'organisation',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'organisations',
        querySortKey: 'organisation',
      },
      {
        text: 'Project',
        value: 'project',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'projects',
        querySortKey: 'project',
      },
      {
        text: 'Location',
        value: 'location',
        align: 'start',
        sortable: true,
        querySortKey: 'location',
      },
      {
        text: 'Site',
        value: 'site',
        align: 'start',
        sortable: true,
        querySortKey: 'site',
      },
      {
        text: 'Device id',
        value: 'device_id',
        align: 'start',
        sortable: true,
        querySortKey: 'device_id',
      },
      {
        text: 'Network id',
        value: 'network_id',
        align: 'start',
        sortable: true,
        querySortKey: 'network_id',
      },
      {
        text: 'Device type',
        value: 'device_type',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'deviceTypes',
        querySortKey: 'device_type',
      },
      {
        text: 'Device deleted on',
        value: 'device_deleted_at',
        align: 'start',
        sortable: true,
        querySortKey: 'device_deleted_at',
      },
      {
        text: 'Device stage',
        value: 'device_stage',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'deviceStages',
        querySortKey: 'device_stage',
      },
      {
        text: 'SIM ICCID',
        value: 'sim_iccid',
        align: 'start',
        sortable: true,
        querySortKey: 'sim_iccid',
      },
      {
        text: 'Auto-renew',
        value: 'autoRenew',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'autoRenew',
        querySortKey: 'auto_renew',
      },
      {
        text: 'Messages in month',
        value: 'messages',
        align: 'start',
        sortable: true,
        querySortKey: 'messages',
      },
      {
        text: '',
        value: 'actions',
        class: 'sticky-column',
        filterable: false,
        sortable: false,
      },
    ],
  };
  private async mounted() {
    EventBus.$on('AccountSubscriptionsTable:LoadSubscriptions', this.loadData);
    this.account = this.activeAccount[0];
    if (this.$route.params.subscriptionOrderId) {
      this.externalFilters = {
        orderNumbers: [Number(this.$route.params.subscriptionOrderId)],
      };
    } else {
      await this.loadData();
    }

  }

  private beforeUnmount() {
    EventBus.$off('AccountSubscriptionsTable:LoadSubscriptions', this.loadData);
  }

  private async loadData(
      queryData: {
        take?: number;
        skip?: number;
        sort?: string;
        desc?: boolean;
        filters?: { [key: string]: any };
        timeFilters?: { [key: string]: Date[] }; } = this.queryData,
      search: string = this.search,
  ) {
    this.loading = true;
    this.selectedSubscriptions = [];
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const mappedTimeFilters = Transformation.timeFiltersToMap(queryData.timeFilters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;
    try {
      const params: {
        organisationId?: number;
        subscriptionOrderId?: number;
        projectId?: number;
        search?: string;
        expiresBetween?: { start: Date | string; end: Date | string };
        expired?: boolean;
        excludeExpired?: boolean;
        excludeInactive?: boolean;
        excludeActive?: boolean;
        excludeNotRenewing?: boolean;
        excludeDetached?: boolean;
        excludeAvailable?: boolean;
      } = {
        subscriptionOrderId: this.selectedSubscriptionOrderId || undefined,
        excludeExpired: this.exclusion === 'expired' || this.exclusion === 'activeexpired',
        excludeInactive: this.exclusion === 'inactive',
        excludeNotRenewing: this.exclusion === 'not_renewing',
        excludeDetached: this.exclusion === 'detached',
        excludeAvailable: this.exclusion === 'available',
        excludeActive: this.exclusion === 'active' || this.exclusion === 'activeexpired',
      };
      if (this.search && this.search.trim().length) {
        params.search = this.search.trim();
      }
      if (this.expiresBetweenSelected && typeof this.expiresBetweenSelected.value !== 'boolean') {
        params.expiresBetween = this.expiresBetweenSelected.value;
      } else if (this.expiresBetweenSelected && typeof this.expiresBetweenSelected.value === 'boolean') {
        params.expired = this.expiresBetweenSelected.value;
      }
      if (this.selectedOrganisation && this.selectedOrganisation.id) {
        params.organisationId = this.selectedOrganisation.id;
      }
      if (this.selectedProject && this.selectedProject.id) {
        params.projectId = this.selectedProject.id;
      }
      const { items, total, counts, columnFilters } = await AccountService.getAccountSubscriptions(
          this.activeAccountId,
          take,
          queryData.skip,
          queryData.sort,
          queryData.desc,
          mappedFilters,
          mappedTimeFilters,
          params,
      );
      const formattedItems = items.map((item: any) => {
        item.autoRenew = item.auto_renew.charAt(0).toUpperCase() + item.auto_renew.slice(1);
        return item;
      });
      Vue.set(this.tableData, 'rows', formattedItems);
      Vue.set(this.tableData, 'total', total);
      Vue.set(this.tableData, 'counts', counts);
      Transformation.setTableFilterValues(this.tableData.headers, columnFilters);
    } finally {
      this.loading = false;
    }
  }

  private formatDate(date: Date) {
    return moment(date).format('DD MMM YYYY HH:mm:ss');
  }

  private async getUsers() {
    const { users } = await AccountService.getAccountUsers(this.activeAccountId, 0, 0, '', false, {}, null);
    Vue.set(this, 'users', users);
  }

  private getUserName(id: number) {
    if (id) {
      const user = this.users.find((item: any) => item.id === Number(id));
      if (user) {
        if (!user.first_name.length && !user.last_name.length) {
          return user.email;
        } else {
          return user.first_name + ' ' + user.last_name;
        }
      }
    } else {
      return 'System';
    }
  }

  private customSort(items: any[]) {
    return items.sort((a, b) => - a.created_at.localeCompare(b.created_at));
  }

  private async exportCsv() {

    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(this.queryData.filters);
    const mappedTimeFilters = Transformation.timeFiltersToMap(this.queryData.timeFilters);
    const take = !this.queryData.take || this.queryData.take === 0 ? this.perPage : this.queryData.take;
    try {
      const params: {
        take: number;
        skip?: number;
        sort?: string;
        desc?: boolean;
        accountId?: number;
        organisationId?: number;
        searchString?: string;
        filters?: any;
        timeFilters?: any;
      } = {
        take: this.queryData.itemsPerPage,
        sort: this.queryData.sort,
      };

      if (this.queryData.page > 1) {
        params.skip = this.queryData.itemsPerPage * (this.queryData.page - 1);
      }
      if (this.queryData.sort) {
        params.desc = !!this.queryData.desc;
      }
      if (this.search && this.search.trim().length) {
        params.searchString = this.search.trim();
      }

      params.accountId = this.activeAccountId;

      function convertToArray(inputObject: any) {
        const outputObject: any = {};

        for (const outerKey in inputObject) {
          if (inputObject.hasOwnProperty(outerKey)) {
            outputObject[outerKey] = [];
            for (const innerKey in inputObject[outerKey]) {
              if (inputObject[outerKey][innerKey]) {
                outputObject[outerKey].push(innerKey);
              }
            }
          }
        }

        return outputObject;
      }
      function convertDatesToArrays(inputObject: any) {
        const outputObject: any = {};

        for (const key in inputObject) {
          if (inputObject.hasOwnProperty(key)) {
            outputObject[key] = [];
            if (inputObject[key] && typeof inputObject[key] === 'object') {
              if (inputObject[key].start) {
                outputObject[key].push(
                    new Date(inputObject[key].start).getTime(),
                );
              }
              if (inputObject[key].end) {
                outputObject[key].push(
                    new Date(inputObject[key].end).getTime(),
                );
              }
            }
            if (outputObject[key].length === 0) {
              delete outputObject[key];
            }
          }
        }
        return outputObject;
      }

      params.filters = {...convertToArray(mappedFilters), ...convertDatesToArrays(mappedTimeFilters)};

      const {job_id} = await AccountService.exportAccountSubscriptions(this.activeAccountId, params);
      EventBus.$emit('accountJobCreated', job_id, true);
    } finally {
      this.loading = false;
    }
  }

  private async getProjects() {
    if (this.selectedOrganisation && this.selectedOrganisation.id) {
      this.projects = (await ProjectService.getProjectsForOrganisation(this.selectedOrganisation.id)).projects;
      this.projects.sort((a: Project, b: Project) => a.name!.toLowerCase().localeCompare(b.name!.toLowerCase()));
    }
  }

  private saveDates() {
    const custom = this.expiresBetweenItems.find((i) => i.id === 7);
    custom.text = this.dates.join(' - ');
    custom.value = { start: this.dates[0], end: this.dates[1] };
    this.expiresBetweenSelected = custom;
    this.menu = false;
    this.loadData();
  }

  private checkboxesSelected(checked: any[]) {
    this.updateActionMenu(checked);
  }

  private updateActionMenu(rows: any[]) {
    if (!rows.length) {
      this.showDisableRenewalSubscriptionAction = this.showTerminateSubscriptionAction = this.showEnableRenewalSubscriptionAction = this.showTransferSubscriptionAction = false;
      return;
    }
    // assigning to a variable for optimization purposes
    const hasAccountManage = this.hasPermission('account:manage');
    this.showTransferSubscriptionAction = hasAccountManage && rows.every((sub: any) => sub.status.toLowerCase() === 'detached');
    this.showDisableRenewalSubscriptionAction = hasAccountManage && rows.every((sub: any) => sub.status.toLowerCase() === 'active');
    this.showEnableRenewalSubscriptionAction = hasAccountManage && rows.every((sub: any) => sub.status.toLowerCase() === 'not renewing');
    this.showTerminateSubscriptionAction = hasAccountManage && rows.every((sub: any) => sub.status.toLowerCase() === 'active' || sub.status.toLowerCase() === 'not renewing');
  }

  private async onQueryDataUpdate(data: any) {
    this.queryData = data;
    await this.loadData(data);
  }

  private async onSearch(search: string) {
    this.search = search;
    this.page = 1;

    await this.$nextTick();
    await this.loadData();
  }

  private clickRow(row: any) {
    if (!!row.device_id) {
      if (!row.gateway_internal_id) {
        this.$router.push(`/organisation/${row.organisation_id}/devices/${row.device_internal_id}`);
      } else {
        this.$router.push(`/organisation/${row.organisation_id}/gateways/${row.gateway_internal_id}`);
      }
    }
  }

  private async openAuditHistory(row: any) {
    this.loadingAudits[row.subscription_id] = true;
    try {
      await this.getUsers();
      this.currentAuditHistory = await AccountService.getAccountSubscriptionAudit(this.activeAccountId, row.subscription_id);
      if (this.currentAuditHistory) {
        this.currentAuditHistory.map((a: any) => a.timestamp = moment(a.created_at).from(moment.now()));
      }

    } finally {
      this.loadingAudits[row.subscription_id] = false;
      this.showAuditHistory = true;
    }
  }

  private async disableRenewal() {
    if (this.selectedSubscriptions.length) {
      this.loadingAction = true;
      const subscriptionIds = this.selectedSubscriptions.map((s) => s.subscription_id);
      try {
        await AccountService.toggleRenewal(this.activeAccountId, subscriptionIds, false);
      } finally {
        this.loadingAction = false;
        this.promptToDisableRenewal = false;
        await this.loadData();
      }
    }
  }
  private async enableRenewal() {
    if (this.selectedSubscriptions.length) {
      this.loadingAction = true;
      const subscriptionIds = this.selectedSubscriptions.map((s) => s.subscription_id);
      try {
        await AccountService.toggleRenewal(this.activeAccountId, subscriptionIds, true);
      } finally {
        this.loadingAction = false;
        await this.loadData();
      }
    }
  }

  private async terminate() {
    if (this.selectedSubscriptions.length) {
      this.loadingAction = true;
      const subscriptionIds = this.selectedSubscriptions.map((s) => s.subscription_id);
      try {
        await AccountService.terminateSubscriptions(this.activeAccountId, subscriptionIds);
      } finally {
        this.loadingAction = false;
        this.promptToTerminate = false;
        await this.loadData();
      }
    }
  }

  private selectExpiresBetween(item: {text: string; value: any}) {
    const custom = this.expiresBetweenItems.find((i) => i.id === 7);
    custom.text = 'Custom range';
    custom.value = { start: undefined, end: undefined };
    if (item && item.text.toLowerCase().includes('custom')) {
      this.menu = true;
    } else {
      this.loadData();
    }
  }

  private get thisWeek() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const d = date.getDate();
    const start = new Date(y, m, d);
    const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 7);
    return { start, end };
  }

  private get next30Days() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const d = date.getDate();
    const start = new Date(y, m, d);
    const end = new Date(y, m, d + 30);
    return { start, end };
  }

  private get thisMonth() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const start = new Date(y, m, 1);
    const end = new Date(y, m + 1, 0);
    return { start, end };
  }

  private get nextMonth() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const start = new Date(y, m, 1);
    const end = new Date(y, m + 1, 0);
    return { start, end };
  }

  private get thisQuarter() {
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const quarter = Math.floor((m / 3));
    const start = new Date(y, quarter * 3, 1);
    const end = new Date(y, start.getMonth() + 3, 0);
    return { start, end };
  }
  private get nextQuarter() {
    const date = new Date();
    let y = date.getFullYear();
    const m = date.getMonth() + 3;
    const quarter = Math.floor((m / 3));
    let start: Date;
    let end: Date;
    if (quarter === 4) {
      ++y;
      start = new Date(y, 0, 1);
      end = new Date(y, start.getMonth() + 3, 0);
      return { start, end };
    }
    start = new Date(y, quarter * 3, 1);
    end = new Date(y, start.getMonth() + 3, 0);
    return { start, end };
  }
}
